export default __webpack_public_path__ + "img/success-loan-icon.0b96ac89.svg";